module.exports = __webpack_public_path__ + "images/emoji/dash.e7883c5dc263c5b89f8b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dash.png
// module id = 3k1n
// module chunks = 24